module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_doctor09-93acae02d068903524921955dae8f839.png";